import { render, staticRenderFns } from "./FloatingStepsMobile.vue?vue&type=template&id=63e2b24c&scoped=true&"
import script from "./FloatingStepsMobile.vue?vue&type=script&lang=ts&"
export * from "./FloatingStepsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingStepsMobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FloatingStepsMobile.vue?vue&type=style&index=1&id=63e2b24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2b24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDialog,VHover,VIcon,VImg})
